<div class="feedback-form">
  <div>
    <div class="first-page" *ngIf="activeIndex == 0">
      <div class="title">Feedback</div>
      <div class="content">
        <div>
          Thank you for taking the course <br/>
          <span>
            '{{ courseDetails?.course?.title }}'
          </span>
        </div>
        <div>We hope it was a good learning experience.</div>
        <div>Please fill out the feedback form. This will help us improve.</div>
        <div>
          Kindly rate us from 1 to 5 on the following aspects, with 1 being poor
          and 5 being excellent.
        </div>
      </div>
    </div>
    <div class="questions" *ngIf="activeIndex > 0">
      <div class="feedback">
        <div class="question">
          <div class="number">{{ activeIndex }}.</div>
          <div class="label">{{ feedbackQuestions[activeIndex] }}</div>
        </div>
        <div
          class="radio-btns answer"
          *ngIf="activeIndex != 8 && activeIndex != 9"
        >
          <div *ngFor="let rating of ratings; let i = index" class="radio-btn">
            <input
              type="radio"
              [value]="rating.value"
              [(ngModel)]="feedbackAnswers[activeIndex]"
              [id]="i"
            />
            <label [for]="i">{{ rating.label }}</label>
          </div>
        </div>
        <div
          class="text-area answer"
          *ngIf="activeIndex == 8 || activeIndex == 9"
        >
          <textarea
            cols="45"
            [(ngModel)]="feedbackAnswers[activeIndex]"
            rows="7"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="btns">
    <div class="back-btn">
      <button *ngIf="activeIndex != 0" (click)="onClickBack()">
        <i class="fas fa-angle-left"></i>
      </button>
    </div>
    <div class="next-submit-btn">
      <button *ngIf="activeIndex < 9" (click)="onClickNext()">
        <i class="fas fa-angle-right"></i>
      </button>
      <button *ngIf="activeIndex == 9" (click)="onClickSubmit()">Submit</button>
    </div>
  </div>
</div>
